import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import { useDividendDocumentModal } from '../context/DividendDocumentModalContext';

const DividendDocumentModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useDividendDocumentModal();

  const isButtonDisabled = !data.selectedPartners?.length;

  return (
    <Modal.Footer>
      <div className="d-flex justify-content-end w-100">
        <button
          type="button"
          className="btn btn-lg btn-primary"
          disabled={isButtonDisabled}
          onClick={actions.handleGenerateDocument}
        >
          {t('Generate')}
        </button>
      </div>
    </Modal.Footer>
  );
};

export default DividendDocumentModalFooter;
